import React from 'react';

type Props = {
    height?: number,
    width?: number,
};

const Wrapper: React.FC<Props> = ({
    children,
    ...props
}) => (
    <div style={props}>{children}</div>
);

Wrapper.defaultProps = {
    height: 130,
    width: 400,
};

export default Wrapper;
